export default "__VITE_PUBLIC_ASSET__9c1b92ce__"